<template>
    <div>
        <span>{{ getValue() }}</span>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
  props: {
    data: {},
    columnData:{},
    status: {}
  },
  data() {
    return {
    }
  },
  components: {},
  created() {
    
  },
  methods: {
    getValue(){
      if (this.data.Value && this.data.Value.length > 100){
        return `${this.data.Value.substring(0, 100)}...`;
      }
      return this.data.Value;
    }
  },
  watch: {
    data: function() {
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/formulaListValueCell.vue